"use client"

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { useEffect } from "react";

let refCalled = false

export const useAirports = () => {
  const airports = useAppSelector(state => state.flight.get_airports.data)
  const airportsCalled = useAppSelector(state => state.flight.get_airports.called)
  
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!!refCalled || !!airportsCalled) return;
    refCalled = true
    dispatch(thunks.get_airports({}))
  }, [airportsCalled])

  return airports
}